// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

export default {
  name: 'workspaces',
  title: 'label.workspaces',
  icon: 'InboxOutlined',
  docHelp: 'workspaces.html',
  permission: ['getWorkspaceStatus', 'getAnsibleStatus'],
  children: [
    {
      name: 'workspaces/overview',
      title: 'label.workspaces.overview',
      icon: 'bars-outlined',
      permission: ['getWorkspaceStatus', 'getAnsibleStatus'],
      component: () => import('@/views/plugins/workspaces/Manage.vue')
    },
    {
      name: 'workspaces/settings',
      title: 'label.workspaces.settings',
      icon: 'setting-outlined',
      permission: ['listWorkspaceManagedScripts', 'updateWorkspaceManagedScripts', 'listWorkspaceConfigurations', 'updateWorkspaceConfiguration'],
      component: () => import('@/views/plugins/workspaces/WorkspaceManagedScripts.vue')
    }
  ]
}
